import HtmlElement from './HtmlElement';

export default HtmlElement;
